import ToggleBlock, { ToggleOption } from '@/components/ToggleBlock';
import type { TimelineItem } from '../types';

export type TimelineToggleProps = {
  className?: string;
  optionClassName?: string;
  value: TimelineItem;
  onChange: (value: TimelineItem) => void;
};

export default function TimelineToggle({
  className,
  optionClassName,
  value,
  onChange,
}: TimelineToggleProps) {
  return (
    <ToggleBlock<TimelineItem>
      className={className}
      value={value}
      onChange={onChange}>
      <ToggleOption className={optionClassName} value="ALL">
        All
      </ToggleOption>
      <ToggleOption className={optionClassName} value="KEYPOINTS">
        Keypoints
      </ToggleOption>
    </ToggleBlock>
  );
}
